module.exports = __webpack_public_path__ + "media/images/bg@2x-c6a9879b541893f3026d0300e1280104.jpeg";